export const resultScreen = {
    'primary-type-1': {
        'top_threshold': {
            'title': 'Amazing!',
            'score_text': ' and won a gold medal.',
            'continue_button_style': 'btn-primary',
            'review_button_style': 'review-btn',
            'tryagain_button_style': 'tryAgain-btn'
        },
        'middle_threshold': {
            'title': 'Nice try!',
            'score_text': ' and won a gold medal.',
            'continue_button_style': 'btn-primary',
            'review_button_style': 'review-btn',
            'tryagain_button_style': 'tryAgain-btn'
        },
        'bottom_threshold': {
            'title': 'Good effort!',
            'score_text': '. Try again and go for gold.',
            'continue_button_style': 'btn-primary',
            'review_button_style': 'review-btn',
            'tryagain_button_style': 'tryAgain-btn'
        }
    },
    'secondary-type-1': {
        'top_threshold': {
            'title': 'Amazing!',
            'score_text': ' and won a gold medal.',
            'continue_button_style': 'btn-primary',
            'review_button_style': 'review-btn',
            'tryagain_button_style': 'tryAgain-btn'
        },
        'middle_threshold': {
            'title': 'Nice try!',
            'score_text': ' and won a gold medal.',
            'continue_button_style': 'btn-primary',
            'review_button_style': 'review-btn',
            'tryagain_button_style': 'tryAgain-btn'
        },
        'bottom_threshold': {
            'title': 'Good effort!',
            'score_text': '. Try again and go for gold.',
            'continue_button_style': 'btn-primary',
            'review_button_style': 'review-btn',
            'tryagain_button_style': 'tryAgain-btn'
        }
    },
    'teacher': {
        'title': 'You have completed the activity',
        'continue_button_style': 'btn-primary',
        'review_button_style': 'review-btn',
        'tryagain_button_style': 'tryAgain-btn'
    }
}
